import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLASS_RESTORE, getProviderAllClasses, getProviderClasses, PROVIDER_GET_CLASSES, resetState, StateStatus } from '@guryou/redux';

const useClasses = (serviceId, all = false) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.classes.all);
  const restore = useSelector(state => state.classes.restore);
  const lastRequestedKey = useRef(null);

  useEffect(() => {
    if (!serviceId) {
      return;
    }
    const requestKey = `${Number(serviceId)}:${all}`;
    const loadedForService = status === StateStatus.LOADED && Number(request?.serviceId) === Number(serviceId);
    if (
      status === StateStatus.NOT_INITIALIZED ||
      (status === StateStatus.LOADED && !loadedForService) ||
      (status === StateStatus.ERROR && lastRequestedKey.current !== requestKey)
    ) {
      lastRequestedKey.current = requestKey;
      if (all) {
        dispatch(getProviderAllClasses(serviceId));
      } else {
        dispatch(getProviderClasses(serviceId));
      }
    }
    if (restore.version) {
      dispatch(resetState(PROVIDER_GET_CLASSES));
      restore.version && dispatch(resetState(CLASS_RESTORE));
    }
  }, [all, data, dispatch, request, restore.version, serviceId, status]);

  if (!serviceId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  return { data: data || [], status, version, entity };
};

export default useClasses;
